import type { SVGProps } from 'react';

const SvgStopBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M8 4V20' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
    <path d='M16 4V20' stroke='currentColor' strokeWidth={2} strokeLinecap='round' />
  </svg>
);
export default SvgStopBd;
